import type { Router } from 'vue-router';

export default function getQueryValue(
    router: Router,
    location: { hash: string },
    ...names: string[]
): (string | undefined)[] {
    // PRODUCT-26110 Phase 2B2: vue-router 3's router.resolve() wrapped its result in
    // { route, location, href } -- vue-router 4's router.resolve() returns the
    // resolved route (RouteLocation & { href }) directly, so params/query are
    // top-level instead of nested under `.location`.
    const { params = {}, query = {} } = router.resolve(location.hash.substr(1));

    return names.map((name) => (name in params ? params[name] : query[name]) as string | undefined);
}
